// data-testid registry for the Printopia landing page
export const NAV = {
  logo: "site-nav-logo",
  linkPremium: "site-nav-link-premium",
  linkCategories: "site-nav-link-categories",
  linkCustom: "site-nav-link-custom",
  linkShipping: "site-nav-link-shipping",
  linkUsa: "site-nav-link-usa-exclusive",
  download: "site-nav-download-button",
  downloadPlay: "site-nav-download-play-button",
  mobileToggle: "site-nav-mobile-toggle",
};

export const HERO = {
  widget: "hero-upload-widget",
  primaryCta: "hero-primary-cta",
  waitlistCta: "hero-join-waitlist-button",
};

export const CATEGORIES = {
  section: "categories-section",
  card: "category-card",
};

export const CUSTOM = {
  section: "custom-prints-section",
  uploadCta: "custom-upload-cta",
  sellCta: "custom-sell-cta",
};

export const HOWITWORKS = {
  section: "how-it-works-section",
  buyerTab: "how-it-works-buyer-tab",
  sellerTab: "how-it-works-seller-tab",
};

export const FEEBAR = {
  root: "fee-bar",
  summary: "fee-bar-summary",
};

export const GALLERY = {
  section: "premium-gallery-section",
  tile: "premium-gallery-tile",
};

export const SHIPPING = {
  section: "shipping-map-section",
  map: "shipping-map-usa",
  stat: "shipping-stat-chip",
  hub: "shipping-map-hub",
};

export const USA = {
  section: "usa-exclusive-section",
};

export const DOWNLOAD = {
  section: "download-cta-section",
  appStore: "download-app-store-button",
  googlePlay: "download-google-play-button",
  email: "waitlist-email-input",
  submit: "waitlist-submit-button",
  success: "waitlist-success-message",
  error: "waitlist-error-message",
};

export const FOOTER = {
  root: "site-footer",
  privacy: "footer-privacy-policy-link",
  contact: "footer-contact-link",
};

export const CONTACT = {
  navButton: "nav-contact-button",
  navButtonMobile: "nav-contact-button-mobile",
  dialog: "contact-dialog",
  name: "contact-name-input",
  email: "contact-email-input",
  message: "contact-message-input",
  submit: "contact-submit-button",
  success: "contact-success-message",
  error: "contact-error-message",
  close: "contact-close-button",
};

export const PRIVACY = {
  page: "privacy-policy-page",
  backHome: "privacy-back-home",
};

export const ADMIN = {
  loginPage: "admin-login-page",
  password: "admin-password-input",
  loginButton: "admin-login-button",
  loginError: "admin-login-error",
  dashboard: "admin-dashboard",
  logout: "admin-logout-button",
  subject: "admin-subject-input",
  body: "admin-body-input",
  save: "admin-save-button",
  reset: "admin-reset-button",
  testEmail: "admin-test-email-input",
  testButton: "admin-test-send-button",
  status: "admin-status-message",
};
